import React from "react";
import TamaraIcon from '../../../assets/svg/tamara.svg';
import FrameBlockResult from '../FrameBlockResult'
import { ApmsTypes } from "../../../constants";

const TamaraResult = ({ link }) => {
    return (
        <FrameBlockResult link={link} apmType={ApmsTypes.Tamara} icon={TamaraIcon} />
    )
}

export default TamaraResult;